import React from 'react'
import { Link } from 'react-router-dom'

import AiAssistantPage, { CheckList, Steps, CodeBlock, Section } from './ai-assistant-page'

const REPO_URL = 'https://github.com/dataflows-au/dataflows-sms-gemini'

const GeminiIntegration = () => (
  <AiAssistantPage
    slug="gemini"
    name="Gemini"
    badge="Gemini CLI Extension"
    title="Gemini CLI SMS Extension | DataFlows"
    description="Send, schedule and track business SMS from your DataFlows account by asking Gemini in plain language. The DataFlows SMS extension works in Gemini CLI."
    heading="DataFlows SMS for Gemini CLI"
    intro="Send, schedule and track business SMS from your DataFlows account by asking Gemini in plain language. The DataFlows SMS extension works in Gemini CLI, and can be imported into Antigravity CLI."
    relatedLink={<Link to="/integrations/claude" className="cliniko-related-link">Claude SMS</Link>}
    heroAction={
      <a href={REPO_URL} target="_blank" rel="noreferrer noopener" className="cliniko-btn-primary">
        View on GitHub
      </a>
    }
  >
    <Section label="Requirements" title="What you need">
      <CheckList items={[
        'A DataFlows account with SMS credits',
        'A sender ID or number on your account (your default sender is used unless you choose another)',
        'Gemini CLI',
      ]} />
    </Section>

    <Section label="Setup" title="Connect in Gemini CLI" id="connect" dark>
      <Steps items={[
        <>
          <p>Run:</p>
          <CodeBlock code={`gemini extensions install ${REPO_URL}`} />
        </>,
        <p>Start Gemini CLI and run: <code>/mcp auth dataflows-sms</code></p>,
        'Sign in with your DataFlows login and select Allow Access.',
        'Ask Gemini to use DataFlows SMS.',
      ]} />
      <div className="cliniko-callout">
        <strong>Using Antigravity CLI?</strong> Install with Gemini CLI first, then run <code>agy plugin import gemini</code>.
      </div>
    </Section>
  </AiAssistantPage>
)

export default GeminiIntegration
